import type { Product } from '@features/product/typings';
import { AvailabilityState } from '@features/product/typings';

import { ActiveMailerButton } from '../ActiveMailerButton';
import { AddToCartContainer } from '../AddToCart';
import { WishlistButton } from '../WishlistButton';

type OrderButtonProps = {
  isLoading?: boolean;
  product: Product;
  privacyPolicyUrl: string;
  feature: 'order_block' | 'sticky_header' | 'order_summary';
  disabled: boolean;
  showWishlistButton?: boolean;
  isInSinterklaasSplitTest?: boolean;
};

export default function OrderButton({
  isLoading,
  product,
  privacyPolicyUrl,
  feature,
  disabled,
  showWishlistButton = false,
  isInSinterklaasSplitTest = false
}: OrderButtonProps) {
  switch (product.availabilityState) {
    case AvailabilityState.AvailableSoon:
    case AvailabilityState.TemporaryOutOfStock:
      return (
        <>
          <ActiveMailerButton
            product={product}
            privacyPolicyUrl={privacyPolicyUrl}
            feature={feature === 'order_summary' ? 'bottom_product_card' : 'order_block'}
          />
          {showWishlistButton && (
            <WishlistButton
              productId={product.id}
              feature={feature}
              isInSinterklaasSplitTest={isInSinterklaasSplitTest}
            />
          )}
        </>
      );

    case AvailabilityState.OnStock:
    case AvailabilityState.PreOrder:
      return (
        <>
          <AddToCartContainer productId={product.id} isLoading={isLoading} disabled={disabled} />
          {showWishlistButton && (
            <WishlistButton
              productId={product.id}
              feature={feature}
              isInSinterklaasSplitTest={isInSinterklaasSplitTest}
            />
          )}
        </>
      );

    default:
      return null;
  }
}
